import { styled } from '@gogovan/entier-web-core/ext/mui/styles';
import gogoxSVG from '@/assets/gogox.svg';

const Container = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: rgb(250, 250, 250);
  min-height: 100vh;
`;

const TopBar = styled('div')`
  width: 100%;
  box-shadow: rgb(0 0 0 / 20%) 0 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px;
  margin-bottom: 40px;
  display: flex;
  min-height: 64px;
  justify-content: space-between;
  align-items: center;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-bottom: 20px;
  }
`;

const ContentWrapper = styled('div')`
  max-width: 928px;
  width: 100%;
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const GogoxIMG = styled(gogoxSVG)`
  height: 24px;
  margin: 0 22px;
`;

const Title = styled('div')`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 56px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 40px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 24px;
    margin-bottom: 16px;
    line-height: 36px;
  }
`;

const mapStyles = (isFullscreen) => (isFullscreen ? { height: '100vh' } : { height: '80vh', p: 2 });

export { Container, ContentWrapper, TopBar, GogoxIMG, Title, mapStyles };
